import ProjectDrawer from './ProjectDrawer';

const projectDrawerRoute = {
  path: '#/project/:projectId',
  component: ProjectDrawer,
  drawerWidth: 775
};

export default projectDrawerRoute;
